import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CommonIcons from '../../icons/Common';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const Guarantees = ({ membershipListData }) => {
	const { t } = useTranslation('orderSummary');

	const guarantees = [
		{
			key: 'securedTransactions',
			label: t('securedTransactions')
		},
		{
			key: 'satisfactionGuarantee',
			label: t('satisfactionGuarantee')
		},
		{
			key: 'noHassleRefunds',
			label: t('noHassleRefunds')
		}
	];

	return (
		<Box>
			<Stack
				direction='row'
				justifyContent='space-between'
				alignItems='center'
				mb={1}
			>
				<Typography variant='body2' sx={{ fontWeight: 600 }}>
					{t('hasCovered', {
						membership: membershipListData?.name
					})}
				</Typography>
				<CommonIcons.shieldWithLock
					sx={{ fontSize: 32, color: 'text.secondary' }}
				/>
			</Stack>

			<Typography
				variant='caption'
				sx={{ color: 'text.secondary', display: 'block', mb: 1.5 }}
			>
				{t('safeAndSecure', {
					membership: membershipListData?.name
				})}
			</Typography>

			<Stack spacing={1}>
				{guarantees.map((item) => (
					<Stack key={item.key} direction='row' alignItems='center' spacing={1}>
						<CommonIcons.check sx={{ fontSize: 18, color: 'green' }} />
						<Typography variant='body2'>{item.label}</Typography>
					</Stack>
				))}
			</Stack>
		</Box>
	);
};

Guarantees.propTypes = {
	membershipListData: PropTypes.object
};

export default Guarantees;
